import styled from 'styled-components';
import { ty } from '@client/styles/typography';

export const Copy = styled.p.attrs({ className: ty('default') })`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3.5em;
  text-align: center;
`;

export const LoadingAnimationStyle = {
  height: '40vh',
  width: '500px',
  maxWidth: '90vw',
  margin: '0 auto',
};

export const AnimationStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;
